/**
 * Created by Carlos on 11/07/2026.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .factory('oneService',oneService);

    oneService.$inject = ['$http', 'CONFIG','messageService'];

    function oneService($http, CONFIG, messageService){
        var urlBase = CONFIG.API_URL + '/' + CONFIG.API_PNR + '/' + CONFIG.API;

        var service = {
            getSearchByData: getSearchByData,
            sendDataReportPost: sendDataReportPost,
            findChannel: findChannel
        };

        return service;

        function getSearchByData(domainId,channel, attr, isTravelConnectAI, userLogin){
            return $http.get(urlBase + '/report-feign/user-details?domainId=' + domainId +'&channel=' + channel + '&attr=' + attr+ '&isTravelConnectAI=' + isTravelConnectAI + '&user_login=' + userLogin)
                .then(function(response){
                    return response;
                }, function(){
                    messageService.findError('');
                });
        }

        function sendDataReportPost(sendType, dto) {
            return $http.post(urlBase + '/report-feign/send-message?sendType=' + sendType, dto)
                .then(function(response) {
                    return response;
                })
                .catch(function(){
                    messageService.findError('');
                });
        }

        function findChannel(login) {
            return $http.get(urlBase + '/message-feign/channels?user_login=' + login)
                .then(function(response){
                    return response;
                }, function(){
                    messageService.findError('');
                });
        }
    }
})();
